import { projectsapi } from "utilities/Axios";



export const postGuideCategory = (data: { name: string }) => {
  return projectsapi.post("/api/Help/category", data);
};

export const getGuideCategories = () => {
  return projectsapi.get("/api/Help/category-with-guides");
};

export const editGuideCategory = (data: any) => {
  return projectsapi.put(`/api/Help/category/${data.id}`, data);
};

export const removeGuideCategory = (data: any) => {
  return projectsapi.delete(`/api/Help/category/${data.id}`);
};


export const postGuide = (data: any) => {
  return projectsapi.post("/api/Help/guide", data);
};

export const getGuides = () => {
  return projectsapi.get("/api/Help/category-with-guides");
};

export const editGuide = (data: any) => {
  return projectsapi.put(`/api/Help/guide/${data.id}`, data);
};

export const removeGuide = (data: any) => {
  return projectsapi.delete(`/api/Help/guide/${data.id}`);
};
